<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Rjhfgc/tc-custom/9781504007009.jpg?1734041378092" alt="This image is the cover for the book Wanted"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wanted
      </h1>
      <p class="bookDescription body article font2">
        <b>A Western beauty’s only hope of saving her brother from the gallows is to seduce the heartless Texas ranger who has sworn to bring him to justice</b><br/><br/> Three months ago, Morgan Davis went from hunter to hunted. The Texas ranger has devoted his life to carrying out justice, but when he sees his face on a Wanted poster, he knows the price on his head will have every bounty hunter in the West gunning for him. The only way to survive is to clear his name by bringing in the real killer. And he intends to take Nicholas Braden alive. But Morgan didn’t reckon on Braden’s sister. The golden-eyed beauty is a crack shot—and a match for any man.<br/><br/> Lori Braden will do anything to save her brother from the hangman’s noose. Their hard-luck life on the road in a traveling medicine show taught her how few people can be trusted. Who is this man Morgan Davis, who bears a resemblance to her brother? Just another corrupt lawman? An enemy she wouldn’t hesitate to kill in spite of the passion raging between them? All she knows about this seductive stranger is that he seems determined to keep her out of the crossfire—until secrets from the past threaten each of their futures.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Potter
      </h2>
      
      <p class="authorDescription body article">Patricia Potter is a <I>USA Today</I>&ndash;bestselling author of more than fifty romantic novels. A seven-time RITA Award finalist and three-time Maggie Award winner, she was named Storyteller of the Year by <I>Romantic Times</I> and received the magazine&rsquo;s Career Achievement Award for Western Romance. Potter is a past board member and president of Romance Writers of America. Prior to becoming a fiction author, she was a reporter for the <I>Atlanta Journal </I>and the president of a public relations firm in Atlanta. She lives in Memphis, Tennessee.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e54a0b98